import React from 'react';
import Banner from '../../components/Banner';
import Navbar from '../../components/Navbar';
import QuaterlyMain from '../../components/QuaterlyAnnual/QuaterlyMain';

function AnnualResults() {
    return (
        <div>
            <Banner />
            <Navbar />
            <QuaterlyMain />
        </div>
    )
}

export default AnnualResults